import React from "react";
import styled from "styled-components";
import Container from "../styles/Container";
import MetricSnippet from "../MetricSnippet";
import { black1 } from "../styles/Colors";
import image from "../../images/76-about-metrics.png";
import { mediaMedium } from "../styles/variables";

const Wrapper = styled.div`
  padding: 96px 0;
  background: url("${image}") center bottom no-repeat ${props => props.backgroundColor || black1};
  background-size: cover;

  @media (${mediaMedium}) {
    padding: 160px 0;
    background-size: 100% 100%;
  }
`;

const Row = styled.div`
  text-align: center;
`;

const Grid = styled(Container)`
  display: grid;
  justify-content: center;
  grid-gap: ${props => props.gridGap || "64px"};

  @media (${mediaMedium}) {
    grid-gap: ${props => props.gridGapDesktop || "88px"};
  }
`;

const HeroMetrics = ({ content, theme }) => {
  // If no content is provided, use default values
  const metricsContent = content || [
    {
      prefix: "$",
      suffix: "M+",
      number: "150",
      description: "Paid to Our Partners"
    },
    {
      suffix: "M+",
      number: "5",
      description: "Products Discovered on Our Platform"
    },
    {
      suffix: "+",
      number: "75",
      description: "Team Members"
    }
  ];

  return (
    <Wrapper backgroundColor={theme?.backgroundColor}>
      <Grid gridGap={theme?.gridGap} gridGapDesktop={theme?.gridGapDesktop}>
        {metricsContent.map((metric, index) => (
          <Row key={`metric-${index}`}>
            <MetricSnippet
              prefix={metric.prefix}
              suffix={metric.suffix}
              number={metric.number}
              description={metric.description}
            />
          </Row>
        ))}
      </Grid>
    </Wrapper>
  );
};

export default HeroMetrics;
